"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class Transaction {
    constructor() {
        this.msgs = [];
        this.fee = 0;
        this.gas = 200000;
        this.memo = '';
    }
    withMessages(...msg) {
        this.msgs.push(...msg);
        return this;
    }
    withAuto(client) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.msgs.length == 0)
                throw Error('Message is empty, please use withMessages at least 1 message.');
            let addr = this.msgs[0].getSender();
            let account = yield client.getAccount(addr);
            if (!account)
                throw Error(`Account doesn't exist.`);
            this.accountNum = account.accountNumber;
            this.sequence = account.sequence;
            return this;
        });
    }
    withAccountNum(accountNum) {
        if (!Number.isInteger(accountNum)) {
            throw Error('accountNum is not an integer');
        }
        this.accountNum = accountNum;
        return this;
    }
    withSequence(sequence) {
        if (!Number.isInteger(sequence)) {
            throw Error('sequence is not an integer');
        }
        this.sequence = sequence;
        return this;
    }
    withChainID(chainID) {
        this.chainID = chainID;
        return this;
    }
    withFee(fee) {
        if (!Number.isInteger(fee)) {
            throw Error('fee is not an integer');
        }
        this.fee = fee;
        return this;
    }
    withGas(gas) {
        if (!Number.isInteger(gas)) {
            throw Error('gas is not an integer');
        }
        this.gas = gas;
        return this;
    }
    withMemo(memo) {
        this.memo = memo;
        return this;
    }
    getSignData() {
        if (this.msgs.length == 0) {
            throw Error('message is empty');
        }
        if (this.accountNum == null) {
            throw Error('accountNum should be defined');
        }
        if (this.sequence == null) {
            throw Error('sequence should be defined');
        }
        if (this.chainID == null) {
            throw Error('chainID should be defined');
        }
        this.msgs.forEach((msg) => msg.validate());
        let messageJson = {
            chain_id: this.chainID,
            account_number: this.accountNum.toString(),
            fee: {
                amount: [
                    {
                        amount: this.fee.toString(),
                        denom: 'uband',
                    },
                ],
                gas: this.gas.toString(),
            },
            memo: this.memo,
            sequence: this.sequence.toString(),
            msgs: this.msgs.map((msg) => msg.asJson()),
        };
        const sortedKey = Object.keys(messageJson).sort();
        const result = {};
        sortedKey.forEach((key) => (result[key] = messageJson[key]));
        return Buffer.from(JSON.stringify(result));
    }
    getTxData(signature, pubkey) {
        if (this.accountNum == null) {
            throw Error('accountNum should be defined');
        }
        if (this.sequence == null) {
            throw Error('sequence should be defined');
        }
        return {
            fee: {
                amount: [{ amount: this.fee.toString(), denom: 'uband' }],
                gas: this.gas.toString(),
            },
            memo: this.memo,
            msg: this.msgs.map((msg) => msg.asJson()),
            signatures: [
                {
                    signature: signature.toString('base64'),
                    pub_key: {
                        type: 'tendermint/PubKeySecp256k1',
                        value: Buffer.from(pubkey.toHex(), 'hex').toString('base64'),
                    },
                    account_number: this.accountNum.toString(),
                    sequence: this.sequence.toString(),
                },
            ],
        };
    }
}
exports.default = Transaction;
